<script setup lang="ts">
import {ref} from "vue";
import EditRecordSectionForm from "components/dialog/record/inner/EditRecordSectionForm.vue";
import {SaveRecordSection} from "@/types";
import {SectionService} from "@/api/api.ts";
import {ElNotification} from "element-plus";

let courseId = 0
let sectionId = 0
const loading = ref(false);
const visible = ref(false)
const editRecordSectionForm = ref<InstanceType<typeof EditRecordSectionForm>>()

const show = (_courseId: number, _sectionId: number) => {
  courseId = _courseId
  sectionId = _sectionId
  visible.value = true
  getSectionInfo()
}

const getSectionInfo = async () => {
  try {
    loading.value = true;
    const res =await SectionService.getSectionInfo({
      course_id: courseId,
      section_id: sectionId
    })
    if (res.data.code === 200) {
      editRecordSectionForm.value?.init(res.data.data)
    } else {
      ElNotification.error({
        title: "获取信息失败",
        message: res.data.msg,
        type: "error"
      })
    }
  } catch (error) {
    console.log(error)
  } finally {
    loading.value = false
  }
}

const hide = () => {
  visible.value = false
}

const emit = defineEmits(['on-submit'])

const onSubmit = (info: SaveRecordSection) => {
  info.section_id = sectionId
  console.log(info)
  emit("on-submit", info)
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog title="编辑章节" width="50rem" align-center v-model="visible">
    <edit-record-section-form ref="editRecordSectionForm" @on-submit="onSubmit" @on-close="hide" v-loading="loading" />
  </el-dialog>
</template>

<style scoped>
</style>
